module.exports = __webpack_public_path__ + "static/media/cockroach(28).fab78d95.PNG";